export default new class Recaptcha {
    constructor() {
        this.promise = null;
    }

    load($input) {
        if (this.promise) {
            return this.promise;
        }

        const { recaptchaHost, recaptchaSitekey, recaptchaLocale } = $input.dataset;

        this.promise = new Promise((resolve, reject) => {
            window.recaptchaLoaded = () => {
                window.grecaptcha.ready(() => resolve(window.grecaptcha));
            };

            const $script = document.createElement('script');
            $script.src = `https://${recaptchaHost}/recaptcha/api.js?render=${recaptchaSitekey}&hl=${recaptchaLocale}&onload=recaptchaLoaded`;
            $script.async = true;
            $script.onerror = () => {
                this.promise = null;
                reject(new Error('reCAPTCHA could not be loaded'));
            };

            document.head.appendChild($script);
        });

        return this.promise;
    }

    async execute($input) {
        const grecaptcha = await this.load($input);
        const { recaptchaSitekey, recaptchaAction } = $input.dataset;

        return grecaptcha.execute(recaptchaSitekey, { action: recaptchaAction });
    }
}();
